<template>
  <!-- <div class="sidebar-form"></div> -->
</template>
<script>
/* eslint-disable */
export default {
  name: 'sidebar-form'
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarForm.vue